export enum AccessModuleTabDetails{
    MineConfigurationModule = 'Mine Configuration Module',
    MinePlanningModule = 'Mine Planning Module',
    MineOptimizationModule = 'Mine Optimization Module',
    DrillandBlastingModule = 'Drill and Blasting Module',
    MineOperationsModule = 'Mine Operations Module',
    GradeControlsModule = 'Grade Controls Module',
    QCLabTab = 'QC Lab Tab',
    QualityTab = 'Quality Tab',
    EquipmentMaintenanceModule = 'Equipment Maintenance Module',
    EquipmentMaintenanceTab = 'Equipment Maintenance Tab',
    CrusherMaintenanceTab = 'Crusher Maintenance Tab',
    MineInsightsModule = 'Mine Insights Module',
}